#import "../../../../graphql/fragments/field-fragment.graphql"

query GetDecisionFields($formId: ID!) {
    form(id: $formId) {
        id
        editableVersion {
            id
            fields {
                ...FieldFragment
            }
        }
    }
}
